import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy, OnInit, PLATFORM_ID, Renderer2, input, inject, DOCUMENT } from "@angular/core";
import {isPlatformServer} from "@angular/common";

const TOOLTIP_DELAY = 500;

@Directive({
  standalone: true,
  selector: '[ui-tooltip]'
})
export class TooltipDirective implements OnInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private ngZone = inject(NgZone);
  private renderer = inject(Renderer2);
  private platformId = inject<Object>(PLATFORM_ID);
  private document = inject<Document>(DOCUMENT);

  readonly tooltipText = input<string | undefined>('', { alias: "ui-tooltip" });

  private tooltipTimeout: any;
  static tooltipElement?: HTMLElement;

  //static hoveredElements = [];
  private enterUnlisten?: () => void;
  private leaveUnlisten?: () => void;

  ngOnInit() {
    this.bindEvents();
  }

  private bindEvents() {
    // No need in tooltips on server side
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.enterUnlisten = this.renderer.listen(this.elementRef.nativeElement, 'mouseover', (e: MouseEvent) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = setTimeout(() => {
          this.createTooltip();
        }, TOOLTIP_DELAY);
      });
    });

    this.leaveUnlisten = this.renderer.listen(this.elementRef.nativeElement, 'mouseout', () => {
      clearTimeout(this.tooltipTimeout);
      this.removeTooltip();
    });
  }

  private createTooltip() {
    this.removeTooltip();
    const tooltipText = this.tooltipText();
    if (!tooltipText) {
      return;
    }
    const el = this.renderer.createElement('div');
    this.renderer.addClass(el, 'ui-anim-fade-in');
    this.renderer.addClass(el, 'ui-anim-scale-in-tooltip');
    this.renderer.addClass(el, 'ui-tooltip');
    const text = this.renderer.createText(tooltipText);
    this.renderer.appendChild(el, text);
    this.renderer.appendChild(this.document.body, el);

    // Position the tooltip
    const pRect = this.elementRef.nativeElement.getBoundingClientRect();
    const tRect = el.getBoundingClientRect();
    this.renderer.setStyle(el, 'top', `${pRect.bottom}px`);
    this.renderer.setStyle(el, 'left', `${pRect.left + (pRect.width/2 - (tRect?.width || 0)/2)}px`);
    this.renderer.setStyle(el, 'left', `${pRect.left + pRect.width/2}px`);

    TooltipDirective.tooltipElement = el;
  }

  private removeTooltip() {
    if (TooltipDirective.tooltipElement && TooltipDirective.tooltipElement.parentNode) {
      TooltipDirective.tooltipElement.parentNode.removeChild(TooltipDirective.tooltipElement);
    }
  }

  ngOnDestroy() {
    if (this.enterUnlisten) {
      this.enterUnlisten();
    }
    if (this.leaveUnlisten) {
      this.leaveUnlisten();
    }
    clearTimeout(this.tooltipTimeout);
    this.removeTooltip();
  }
}
